// --- Braze Content Card ---
export enum BRAZE_CONTENT_CARD {
  PATIENT_REFILL = 'patient_refill',
  PATIENT_REFILL_PHARMACY = 'patient_refill_pharmacy',
  ESCRIPT_REFILL = 'escript_refill',
  ESCRIPT_REFILL_PHARMACY = 'escript_refill_pharmacy',
  PATIENT_ORDERS = 'patient_orders',
  ESCRIPT_ORDERS = 'escript_orders',
}
